import type { GridBlock as GridBlockType, GridVariant } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { slugify } from '@shared/Frontend/utils/slugify'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'
import { InternalLink } from '@shared/Frontend/utils/link'
import { SVGIcon } from '@shared/Frontend/utils/svg'

// TODO: COPIED OVER GRIDBLOCK AND USE TYPES FROM THIS, MAYBE THIS SHOULD BE SEPERATED

export const SimpleGridBlock: BlocksView['GridBlock'] = (props) => {
  const { id, title, items, variant } = props
  const { inView, ref } = useInView({ threshold: 0.1 })

  const subHeading = title ? 'h3' : 'h2'

  return (
    <section id={id} ref={ref} className={cn(`block block--simplegrid simplegrid--${variant} ls-spacing`, inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        <div className="block__content--full">
          <ListLayout items={items} variant={variant} subHeading={subHeading} listClassName="block__list" />
        </div>

        <BlockActions {...props} datalayerCategory="grid_block" />
      </div>
    </section>
  )
}

export const ListLayout = (props: {
  items: GridBlockType['items']
  variant: GridVariant
  subHeading: 'h2' | 'h3'
  listClassName?: string
}) => {
  const { listClassName, items, variant, subHeading } = props
  return (
    <ul className={`simplegrid ${listClassName || ''}`}>
      {items.map((item, index) => {
        return <ItemLayout key={`${index}-${item.title}`} {...item} subHeading={subHeading} variant={variant} />
      })}
    </ul>
  )
}

const ItemLayout = (
  props: { subHeading: 'h2' | 'h3'; variant: GridBlockType['variant'] } & GridBlockType['items'][number]
) => {
  const { subHeading, image, link, title, variant } = props
  const hasAction = link && link.url && link.label
  const SubHeading = subHeading
  const { inView, ref } = useInView<HTMLLIElement>({ threshold: 0.2 })
  return (
    <li ref={ref} className={cn('simplegrid__item', inView && 'inview')}>
      <article className="simplegrid__article">
        {variant == 'image' && image && (
          <div className="simplegrid__visual fit-object" aria-hidden="true">
            <Img {...image} loading="lazy" className="simplegrid__image" width="80" height="80" sizes='80px' />
          </div>
        )}

        {variant == 'text' && hasAction && (
          <SVGIcon className="simplegrid__icon" id='icon-chevron-right' size={20} />
        )}

        {(title || hasAction) && (
          <div className="simplegrid__text">
            {(title) && (
              <header className="simplegrid__header">
                <SubHeading id={slugify(title)} className="simplegrid__title text--lg">
                  {title}
                </SubHeading>
              </header>
            )}

            {hasAction && (
              <footer className="simplegrid__footer">
                <InternalLink {...link} className='simplegrid__clickable'>
                  <span className='sr-text'>Lees verder</span>
                </InternalLink>
              </footer>
            )}
          </div>
        )}
      </article>
    </li>
  )
}
